import DealsEvolvedWithTabs from './DealsEvolvedWithTabs';

import DealsEvolved from '.';

import type { DealsEvolvedProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DealsEvolved';

const DealsEvolvedWrapper = (props: DealsEvolvedProps) =>
  props.filteringTabDeals ? (
    <DealsEvolvedWithTabs {...props} />
  ) : (
    <DealsEvolved {...props} />
  );

export default DealsEvolvedWrapper;
